import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { girisYapilmis } from '../services/authApi';

function PrivateRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={props =>
        girisYapilmis()
          ? <Component {...props} />
          : <Redirect to="/login" />
      }
    />
  );
}

export default PrivateRoute
